import React from 'react';

function InfoIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
      <g fill="#055C79" clipPath="url(#clip0_4087_33734)">
        <path d="M9 .5a9 9 0 109 9 9.01 9.01 0 00-9-9zM9 17a7.5 7.5 0 117.5-7.5A7.509 7.509 0 019 17z"></path>
        <path d="M9 8h-.75a.75.75 0 100 1.5H9V14a.75.75 0 101.5 0V9.5A1.5 1.5 0 009 8zM9 6.5a1.125 1.125 0 100-2.25A1.125 1.125 0 009 6.5z"></path>
      </g>
      <defs>
        <clipPath id="clip0_4087_33734">
          <path fill="#fff" d="M0 0H18V18H0z" transform="translate(0 .5)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default InfoIcon;
